module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-about-us-doctors"
  }, [_c('div', {
    staticClass: "slider-about-us-doctors__container"
  }, [_c('div', {
    staticClass: "slider-about-us-doctors__slider"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 2,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#30a4cd",
      "paginationColor": "#fff",
      "paginationSize": 15
    }
  }, _vm._l((_vm.props.gallery), function(slide, i) {
    return _c('Slide', {
      key: i
    }, [_c('div', {
      staticClass: "slider-about-us-doctors__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })])
  }), 1)], 1), _c('div', {
    staticClass: "slider-about-us-doctors__slider--mobile"
  }, [_c('Carousel', {
    attrs: {
      "navigationEnabled": true,
      "autoplay": false,
      "perPage": 1,
      "loop": true,
      "navigationNextLabel": _vm.arrowNext,
      "navigationPrevLabel": _vm.arrowPrev,
      "paginationActiveColor": "#30a4cd",
      "paginationColor": "#fff",
      "paginationSize": 10
    }
  }, _vm._l((_vm.props.gallery), function(slide, i) {
    return _c('Slide', {
      key: i
    }, [_c('div', {
      staticClass: "slider-about-us-doctors__slide",
      style: ({
        backgroundImage: 'url(' + slide.url + ')'
      })
    })])
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-952f0b3c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/slider/slider-about-us-doctors/slider-about-us-doctors.pug
// module id = 588
// module chunks = 1